<template>
  <div>
    <div class="mb-1">
      RackSubGroup Reports:
    </div>
    <b-table
      responsive
      striped
      hover
      :items="reports"
      :fields="tableFields"
      class="compact-table"
      show-empty
      empty-text="No Records to display!"
    >
      <template #cell(status)="{item}">
        <app-chip :variant="getStausChipVariant(item.status)">
          {{ item.status }}
        </app-chip>
      </template>
      <template #cell(created_at)="{item}">
        {{ item.created_at && formatedDate(item.created_at, 'DD-MM-YY LT') || '-' }}
      </template>
      <template #cell(pickup_initiated_at)="{item}">
        {{ item.pickup_initiated_at && formatedDate(item.pickup_initiated_at, 'DD-MM-YY LT') || '-' }}
      </template>
      <template #cell(pickup_completed_at)="{item}">
        {{ item.pickup_completed_at && formatedDate(item.pickup_completed_at, 'DD-MM-YY LT') || '-' }}
      </template>
    </b-table>
  </div>

</template>

<script>
import {
  BTable,
} from 'bootstrap-vue'
import AppChip from '@/components/UI/AppChip.vue'
import dateMixin from '@/mixins/dateMixin'
import { BILL_RSG_STATUS_STATUS_OPTIONS } from '@/utils/consts'

export default {
  components: {
    BTable,
    AppChip,
  },
  mixins: [dateMixin],
  props: {
    reports: { type: Array, required: true },
  },
  data() {
    return {
      tableFields: [
        { key: 'rack_sub_group_no', label: 'Sub Group Report' },
        { key: 'status', label: 'Status' },
        { key: 'created_at', label: 'Created At' },
        { key: 'pickup_initiated_by_name', label: 'Pickup Initiated By' },
        { key: 'pickup_initiated_at', label: 'Pickup Initiated At' },
        { key: 'pickup_completed_at', label: 'Pickup Completed At' },
      ],
    }
  },
  methods: {
    getStausChipVariant(value) {
      if (value === BILL_RSG_STATUS_STATUS_OPTIONS.CREATED) {
        return 'secondary'
      }

      if (value === BILL_RSG_STATUS_STATUS_OPTIONS.READY) {
        return 'primary'
      }

      if (value === BILL_RSG_STATUS_STATUS_OPTIONS.PICKUP_INITIATED) {
        return 'warning'
      }

      if (value === BILL_RSG_STATUS_STATUS_OPTIONS.PICKUP_COMPLETED) {
        return 'success'
      }

      return 'secondary'
    },
  },
}

</script>
